module.exports = __webpack_public_path__ + "static/media/facebook-col-icon.ee75d6b9.svg";